var map = {
	"./banner.png": 22313,
	"./cards/01_PredictionCardWeb.png": 31610,
	"./cards/02_PredictionCardWeb.png": 71841,
	"./cards/03_PredictionCardWeb.png": 37012,
	"./cards/04_PredictionCardWeb.png": 37899,
	"./cards/05_PredictionCardWeb.png": 81318,
	"./cards/06_PredictionCardWeb.png": 18317,
	"./cards/07_PredictionCardWeb.png": 27504,
	"./cards/08_PredictionCardWeb.png": 29783,
	"./cards/09_PredictionCardWeb.png": 54050,
	"./cards/10_PredictionCardWeb.png": 4772,
	"./cards/11_PredictionCardWeb.png": 93841,
	"./cards/12_PredictionCardWeb.png": 81610,
	"./cards/13_PredictionCardWeb.png": 33919,
	"./cards/14_PredictionCardWeb.png": 32384,
	"./cards/15_PredictionCardWeb.png": 20797,
	"./cards/16_PredictionCardWeb.png": 93270,
	"./cards/17_PredictionCardWeb.png": 12827,
	"./cards/18_PredictionCardWeb.png": 3948,
	"./cards/19_PredictionCardWeb.png": 46425,
	"./cards/20_PredictionCardWeb.png": 57253,
	"./cards/21_PredictionCardWeb.png": 75432,
	"./cards/22_PredictionCardWeb.png": 51619,
	"./cards/23_PredictionCardWeb.png": 56958,
	"./cards/24_PredictionCardWeb.png": 50649,
	"./cards/25_PredictionCardWeb.png": 61900,
	"./cards/26_PredictionCardWeb.png": 83783,
	"./cards/27_PredictionCardWeb.png": 82002,
	"./cards/28_PredictionCardWeb.png": 33821,
	"./en.png": 17042,
	"./english.png": 12451,
	"./largebanner/banner-1.png": 11989,
	"./largebanner/banner-2.png": 9886,
	"./largebanner/banner-3.png": 97575,
	"./logo.png": 82806,
	"./marker.png": 62333,
	"./mm.png": 44225,
	"./myanmar.png": 59458,
	"./pdf_logo.png": 93223,
	"./placeholder.png": 16628,
	"./profile.png": 45572,
	"./profile_medium.png": 2300,
	"./smallbanner/banner-1.png": 25389,
	"./smallbanner/banner-2.png": 18358,
	"./smallbanner/banner-3.png": 96447,
	"./smilegirl.png": 21681,
	"./sypitarn_mascot.png": 69369,
	"./th.png": 41855,
	"./thailand.png": 17474,
	"./whatwedo.png": 48114
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 94504;